<div *ngFor="let mode of modes$ | async" [class]="mode.class">
  <div class="container-fluid my-0">
    <div class="row">
      <div class="col-24">
        <div class="content-box pb-0 pt-0 heading-xs m-0 text-truncate text-bold bl-h-2">
          <ng-container *ngIf="mode.type === modeType.QA; else employeeTpl">
            QA MODE: {{ mode.data.label }}
          </ng-container>
          <ng-template #employeeTpl>
            <div class="d-flex justify-content-between align-items-center">
              <span class="logged-text pe-2">
                <span [ngClass]="{ 'd-none d-md-inline': modeType.AM === mode.type }">
                  {{ 'header.account.loggedInAs' | i18next }}
                </span>
                <ng-container *ngIf="mode.data as data">
                  <ng-container *ngIf="modeType.AM === mode.type; else formattedTpl">
                    {{ data.company }}
                    <span class="d-none d-md-inline">{{ data.company2 }}</span>
                    -
                    <ng-container *ngIf="data.preselectedShipToId as shipToId">Ship-To: {{ shipToId }} -</ng-container>
                    {{ 'header.meta.contact' | i18next }}: {{ data.firstName }} {{ data.lastName }}
                  </ng-container>
                  <ng-template #formattedTpl>{{ data.formatted }}</ng-template>
                </ng-container>
              </span>
              <a
                [href]="eVoucherRoute"
                shrdUicButton
                variant="link"
                class="m-0 text-white bl-h-2 flex-shrink-0 link-evouchers"
              >
                <span>{{ 'header.label.eVoucherHub' | i18next }}</span>
                <shrd-uic-svg-icon
                  [size]="sizeOption.SMALL"
                  [icon]="iconName.SHIPMENT"
                  [inheritColor]="true"
                ></shrd-uic-svg-icon>
              </a>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
